import { HTTP } from "../../../services/api-service.js";
import commonObj from "../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "SalesOrder";

const salesOrderStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0
  },
  actions: {
    getSalesOrderList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/SO/GetSOList", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    copySODetails({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/salesOrder/copyso", {
          SONum: param.SONum,
          entNum: param.entNum,
          loc: param.loc
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getBySalesOrderNo({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/SO/GetSO", { soNumber: param.soNumber })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getEventCodeList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/SO/GetEventList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getRefSOList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/salesOrder/getrefsolist", {
          entNum: param.entNum,
          itemNum: param.itemNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    copyFromQuote({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/so/CopyFromQuote", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    soPxHist({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/so/SOPxHistory", {
          entNum: param.entNum,
          itemNum: param.itemNum,
          curCode: param.curCode,
          exRate: param.exRate
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveSalesOrder({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/SO/SaveSO", JSON.stringify({ so: param.so,soType: param.soType }))
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    revisionSalesOrder({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/SO/SaveSORev", JSON.stringify({ so: param.so }))
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    PostSO({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/so/PostSO",
          JSON.stringify({ soNum: param.soHdrNum })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteSalesOrder({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/SO/delete",
          JSON.stringify({ soHdrNum: param.soHdrNum })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    soRpt({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/so/sorpt")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printSO({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/SO/Print",
          { txNum: param.txNum, rptID: param.rptID },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default salesOrderStore;
